import React, { FC } from 'react';

import { Box } from '@mui/system';
import { Typography } from '@mui/material';

import { ReactComponent as Ticker } from '../../../../assets/svg/customTicker.svg';
import { SkeletonVariants } from '../../../../helpers/Constants';
import ThemeConstants from '../../../../theme/ThemeConstants';
import { approvalTime } from '../../../Reports/helpers';
import WithSkeleton from '../../../common/WithSkeleton';
import strings from '../../../../localization';

import GoToPharmacistChat from './GoToPharmacistChat';
import styles from './styles';

interface IPharmacistCardHeader {
  showTicker: boolean;
  successAction: string;
  timezone?: string;
  bookingStateExpiration?: string;
}

const PharmacistCardHeader: FC<IPharmacistCardHeader> = ({
  showTicker,
  successAction,
  bookingStateExpiration,
  timezone,
}) => {
  const confirmTime = approvalTime(bookingStateExpiration ?? '');
  const date = `${confirmTime} ${timezone}`;
  const confirmBefore = `${strings.formatString(strings.confirmBefore, date)}`;

  const SkeletonTypography = WithSkeleton({
    successAction,
    variant: SkeletonVariants.text,
  })(Typography);

  return (
    <Box sx={styles.container}>
      <Box>
        {showTicker && (
          <Box sx={styles.confirmContainer}>
            <Ticker stroke={ThemeConstants.pharmacy.requested} />
            <SkeletonTypography sx={styles.label}>
              {confirmBefore}
            </SkeletonTypography>
          </Box>
        )}
      </Box>
      <GoToPharmacistChat />
    </Box>
  );
};

export default PharmacistCardHeader;
